import http from '../http';

// 消费入账
const creditConsume = (data) => {
  return http({
    url: '/bill/consume/post',
    method: 'POST',
    data,
  });
};

// ota预付款入账
const creditOtaAmount = (data) => {
  return http({
    url: '/bill/ota/post',
    method: 'POST',
    data,
  });
};

// 加收房费
const appendRoomFee = (data) => {
  return http({
    url: '/bill/append/room/fee',
    method: 'POST',
    data,
  });
};

export { creditConsume, creditOtaAmount, appendRoomFee };
